/**
 * @fileoverview CardMetaItem component
 * Displays a single metadata item with label and value pair
 * Used within CardContent to show deal details like deal type, trade-in, sales rep, and deal status
 */

import type { MetaItemProps } from '../../types';
import { StyledMetaItem } from './CardMetaItem.style';

/**
 * CardMetaItem component
 * Renders a key-value pair for displaying deal metadata:
 * - Label: The descriptive name of the metadata field
 * - Value: The actual value for that field
 *
 * @param label - The label text describing the metadata field
 * @param value - The value to display for this metadata field
 * @returns Styled metadata item with label and value
 */
const CardMetaItem: React.FC<MetaItemProps> = ({ label, value }) => (
    <StyledMetaItem>
        <span className="label">{label}</span>
        <span className="value">{value}</span>
    </StyledMetaItem>
);

export default CardMetaItem;
